/**
 * LE PROFIL DU PUBLIC D'UNE CLASSE — adultes, ados, enfants ou mixte.
 *
 * POURQUOI UN MODULE PLUTÔT QUE QUATRE LISTES RECOPIÉES. Le champ se saisit dans trois
 * formulaires (commerciale, onboarding, assignation) et s'affiche dans autant de modales de
 * détail. Une liste recopiée à chaque endroit finit par diverger : il suffit qu'un écran
 * propose « Ados » et un autre « Adolescents » pour que la base contienne les deux, et la
 * contrainte posée par `Backend/sql/public_cible_classes_migration.sql` refuse alors la
 * création sans que personne comprenne pourquoi.
 *
 * LES CLÉS SONT CELLES DE LA BASE, et ne se traduisent pas : `adultes`, `ados`, `enfants`,
 * `mixte`. Le libellé affiché, lui, peut changer librement — c'est tout l'intérêt de les
 * séparer.
 *
 * LE CHAMP N'EST PAS OBLIGATOIRE. `null` est un état légitime : celui des classes créées
 * avant ce champ, et celui d'une classe dont on ne sait pas encore. Lui donner « adultes »
 * par défaut inventerait une information que personne n'a saisie et la rendrait
 * indiscernable d'un choix réel — or c'est précisément la distinction qui permet de
 * retrouver les fiches à compléter.
 */
export const PUBLICS_CIBLES = [
  { cle: "adultes", libelle: "Adultes", emoji: "🧑‍💼", aide: "Professionnels, étudiants, particuliers majeurs" },
  { cle: "ados",    libelle: "Ados",    emoji: "🎒",   aide: "Collégiens et lycéens — rythme et supports adaptés" },
  { cle: "enfants", libelle: "Enfants", emoji: "🧒",   aide: "Primaire et maternelle — séances courtes et ludiques" },
  { cle: "mixte",   libelle: "Mixte",   emoji: "👥",   aide: "Public hétérogène, typiquement une classe entreprise" },
];

/* Le libellé d'affichage d'une clé. Rend `null` quand rien n'est renseigné — à l'appelant
   de décider comment le dire (« Non renseigné », un tiret, ou rien du tout selon la place
   dont il dispose), plutôt que d'imposer ici une formulation à tous les écrans.
   UNE CLÉ INCONNUE EST RENDUE TELLE QUELLE au lieu d'être effacée : si une valeur
   inattendue atterrit en base, mieux vaut la voir à l'écran que la faire disparaître. */
export function libellePublicCible(cle) {
  if (!cle) return null;
  const p = PUBLICS_CIBLES.find(x => x.cle === cle);
  return p ? p.libelle : cle;
}

export function emojiPublicCible(cle) {
  return PUBLICS_CIBLES.find(x => x.cle === cle)?.emoji || "";
}

/* Libellé prêt à afficher, emoji compris, avec un repli explicite quand le champ est vide. */
export function publicCibleAffiche(cle, siVide = "Non renseigné") {
  if (!cle) return siVide;
  const p = PUBLICS_CIBLES.find(x => x.cle === cle);
  return p ? `${p.emoji} ${p.libelle}` : cle;
}

export default PUBLICS_CIBLES;
